//
//
//
//
//
//
//
const GlobalTitle = () => import(
/* webpackChunkName:"global-editorial" */
'~/components/atoms/Editorial/Global/GlobalTitle.vue');

export default {
  name: 'TitleSection',
  components: {
    GlobalTitle
  },
  props: {
    title: {
      type: Object,
      required: true
    },
    textColor: {
      type: String,
      default: ''
    }
  }
};